module.exports = __webpack_public_path__ + "static/media/background2.6099a125.jpg";